import React from "react";
import { totalStats } from "../mock";
import { WavyRule } from "./Guilloche";
import { Lock, FileText, Fingerprint, Sparkles } from "lucide-react";

const CARDS = [
  {
    icon: Lock,
    title: "Zcash cannot hold assets yet",
    body: "Shielded assets are specified — ZIP 226 and ZIP 227 — but they are drafts. They are not on mainnet, and the next network upgrade does not include the transaction format they need.",
  },
  {
    icon: FileText,
    title: "Zcash can hold inscriptions today",
    body: "An inscription needs no new consensus rules. It is an ordinary transparent transaction carrying data, which Zcash has accepted since the beginning. Around 113,000 already exist on mainnet.",
  },
  {
    icon: Fingerprint,
    title: "So the stamp is the asset",
    body: "Not a placeholder image. A record of one specific destruction, written to the chain the asset will eventually live on. Each stamp maps to exactly one burn and can be claimed once.",
  },
  {
    icon: Sparkles,
    title: "Uniqueness is doing real work",
    body: "A balance cannot say that this destruction happened, on this date, for this amount, to this person. Only a unique record can. When shielded assets activate, each stamp converts to the amount cut into it.",
  },
];

export default function WhyStamp() {
  return (
    <section id="why" className="relative" style={{ background: "var(--bg-2)", borderTop:"1px solid var(--border)", borderBottom:"1px solid var(--border)" }}>
      <div className="container-x py-16 md:py-20">
        <h2 className="font-number font-semibold" style={{ fontSize: "clamp(1.6rem,3.4vw,2.3rem)" }}>Why a stamp, and not a token</h2>
        <WavyRule className="my-6 max-w-3xl" />
        <div className="mt-6 grid md:grid-cols-2 gap-4">
          {CARDS.map((c, i) => {
            const Icon = c.icon;
            return (
              <div key={i} className="rounded-sm p-6 transition-transform hover:-translate-y-1" style={{ background:"var(--card)", border:"1px solid var(--border)" }}>
                <div className="h-10 w-10 rounded-sm grid place-items-center mb-4" style={{ background:"rgba(227,179,65,0.1)", border:"1px solid rgba(227,179,65,0.28)" }}>
                  <Icon size={19} className="gold-text" />
                </div>
                <h3 className="font-number font-semibold text-[18px]">{c.title}</h3>
                <p className="mt-3 text-[14px] leading-relaxed" style={{ color:"var(--muted)" }}>{c.body}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 gap-4">
          <Stat value={totalStats.inscriptionsOnZcash.toLocaleString()+"+"} label="Inscriptions on Zcash mainnet" />
          <Stat value={totalStats.certificates} label="Certificates issued" />
          <Stat value={totalStats.totalDestroyed.toLocaleString()} label="Tokens destroyed" />
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div className="rounded-sm p-5" style={{ background:"var(--card)", border:"1px solid var(--border)" }}>
      <div className="font-number font-semibold gold-text" style={{ fontSize:"1.9rem" }}>{value}</div>
      <div className="text-[12.5px] mt-1" style={{ color:"var(--muted)" }}>{label}</div>
    </div>
  );
}
